<template>
  <div>
    <b-row class="mb-1">
      <b-col>
        <b-button variant="primary" :to="{ name: 'InvoiceInfo-Create' }">
          <span class="text-nowrap">Create Invoice Info</span>
        </b-button>
      </b-col>
    </b-row>
    <b-card title="Invoice Company Information">
      <vue-good-table
        :rows="rows"
        :columns="columns"
        :pagination-options="{
          enabled: true,
          perPage: pageLength,
        }"
      >
        <!-- Column: Action  -->
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field === 'action'">
            <span>
              <b-dropdown
                variant="link"
                toggle-class="text-decoration-none"
                no-caret
              >
                <template v-slot:button-content>
                  <feather-icon
                    icon="MoreVerticalIcon"
                    size="16"
                    class="text-body align-middle mr-25"
                  />
                </template>
                <b-dropdown-item
                  :to="{
                    name: 'InvoiceInfo-Details',
                    params: { id: props.row.company_id },
                  }"
                  variant="info"
                >
                  <feather-icon icon="InfoIcon" class="mr-50" />
                  <span>Details</span>
                </b-dropdown-item>
                <b-dropdown-item
                  :to="{
                    name: 'InvoiceInfo-Edit',
                    params: { id: props.row.company_id },
                  }"
                  variant="warning"
                >
                  <feather-icon icon="Edit2Icon" class="mr-50" />
                  <span>Edit</span>
                </b-dropdown-item>
              </b-dropdown>
            </span>
          </span>
        </template>
        <!-- pagination -->
        <template slot="pagination-bottom" slot-scope="props">
          <div class="d-flex justify-content-between flex-wrap">
            <div class="d-flex align-items-center mb-0 mt-1">
              <span class="text-nowrap"> Showing 1 to </span>
              <b-form-select
                v-model="pageLength"
                :options="['5', '10', '15', '30']"
                class="mx-1"
                @input="
                  (value) => props.perPageChanged({ currentPerPage: value })
                "
              />
              <span class="text-nowrap"> of {{ props.total }} entries </span>
            </div>
            <div>
              <b-pagination
                :value="1"
                :total-rows="props.total"
                :per-page="pageLength"
                class="mt-1 mb-0"
                @input="(value) => props.pageChanged({ currentPage: value })"
              >
              </b-pagination>
            </div>
          </div>
        </template>
      </vue-good-table>
      <b-overlay :show="isLoading" no-wrap rounded="sm" />
    </b-card>
  </div>
</template>

<script>
import {
  BTable,
  BRow,
  BCol,
  BFormSelect,
  BFormGroup,
  BPagination,
  BCard,
  BButton,
  BOverlay,
  BDropdown,
  BDropdownItem,
} from "bootstrap-vue";
import axios from "@axios";

export default {
  name: "InvoiceInfo",
  components: {
    BTable,
    BRow,
    BCol,
    BFormSelect,
    BFormGroup,
    BPagination,
    BCard,
    BButton,
    BOverlay,
    BDropdown,
    BDropdownItem,
  },
  data() {
    return {
      isLoading: false,
      pageLength: 5,
      selectedDir: false,
      columns: [
        {
          label: "Company Name",
          field: "company_name",
        },
        {
          label: "Company Id",
          field: "company_id",
        },
        {
          label: "Company Code",
          field: "company_code",
        },
        {
          label: "Company Address",
          field: "invoice_address.address",
        },
        {
          label: "Bank Name",
          field: "bank_details.bank_name",
        },
        {
          label: "Beneficiary Name",
          field: "bank_details.beneficiary_name",
        },
        {
          label: "Account Number",
          field: "bank_details.account_number",
        },
        {
          label: "Signatory Name",
          field: "signatory.name",
        },
        {
          label: "Signatory Position",
          field: "signatory.position",
        },
        {
          label: "Action",
          field: "action",
        },
      ],
      rows: [],
    };
  },
  created() {
    this.getInvoiceInfo();
  },
  methods: {
    getInvoiceInfo() {
      this.isLoading = true;
      axios
        .get("/Invoice/api/V1.0/Invoice/GetAllInvoiceInfo")
        .then((res) => {
          this.rows = res.allCompanyInvoiceInformation;
          this.isLoading = false;
        })
        .catch((err) => console.log(err));
    },
  },
};
</script>

<style lang="scss" scoped></style>
